/// <amd-module name="Feed/Legacy/Protocols/Maven/GradleClientTool" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import { FeedView } from "Feed/Common/Contracts/Feed";
import { BowtieIconProps } from "Feed/Common/Utils/Icons";
import { IPackageProtocolClient } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { GradleConnectToFeedPanel, IGradleConnectToFeedPanelProps } from "Feed/Legacy/Protocols/Maven/GradleConnectToFeedPanel";
import { HubAction } from "Feed/Legacy/Types/IHubState";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export class GradleClientTool implements IPackageProtocolClient {
    public readonly name = "Gradle";
    public readonly vssIconProps = new BowtieIconProps("brand-gradle");

    private pageContext: IVssPageContext;

    constructor(pageContext: IVssPageContext) {
        this.pageContext = pageContext;
    }

    public getConnectPanel(feed: Feed, feedViews: FeedView[], hubAction: HubAction): JSX.Element {
        return React.createElement(GradleConnectToFeedPanel, {
            pageContext: this.pageContext,
            feed,
            feedViews,
            hubAction
        } as IGradleConnectToFeedPanelProps);
    }
}
